import env from '../services/environment'
import cookie from '../services/cookie'
import functions from '../services/functions'
import jwtDecode from 'jwt-decode'

const AuthPlugin = {
  install (Vue, options) {
    let idToken = null
    let accountUrl = 'https://' + env.authTargetPath
    let loginUrl = accountUrl + '/login;hl=en;service=email;continue=' + window.btoa(window.location.origin + '/home')
    let loginUrlLocalStorage = accountUrl + '/login;hl=en;service=email;auth_type=local_storage;continue=' + window.btoa(window.location.origin + '/home')
    let logoutUrl = accountUrl + '/logout;hl=en;service=email;continue=' + window.btoa(window.location.origin + '/home')
    let logoutUrlLocalStorage = accountUrl + '/logout;hl=en;service=email;auth_type=local_storage;continue=' + window.btoa(window.location.origin + '/home')

    let getIdTokenFromCookie = function () {
      return cookie.getCookie('chekt::id_token') ? cookie.getCookie('chekt::id_token') : null
    }
    let getIdTokenFromLocalStorage = function () {
      return localStorage.getItem('chekt::id_token') ? functions.decodeFromBase64Url(localStorage.getItem('chekt::id_token')) : null
    }
    let removeIdTokenFromLocalStorage = function () {
      localStorage.removeItem('chekt::id_token')
    }
    let storeIdTokenToLocalStorage = function (idToken) {
      localStorage.setItem('chekt::id_token', idToken)
    }
    let tokenExpirationTimeLeft = function (token) {
      let decodedToken = jwtDecode(token)
      let now = new Date()
      return decodedToken.exp * 1000 - now.getTime()
    }

    let authenticated = function () {
      let isAuthenticated = false
      let idToken = null
      if (env.isChektDomain) idToken = getIdTokenFromCookie()
      else idToken = getIdTokenFromLocalStorage()
      if (idToken) {
        try {
          if (+tokenExpirationTimeLeft(idToken) > 0) isAuthenticated = true
        } catch (err) {
          isAuthenticated = false
        }
      }
      return isAuthenticated
    }
    let login = function () {
      if (env.isChektDomain) window.location.href = loginUrl
      else window.location.href = loginUrlLocalStorage
    }
    let logout = function () {
      if (env.isChektDomain) window.location.href = logoutUrl
      else {
        removeIdTokenFromLocalStorage()
        window.location.href = logoutUrlLocalStorage
      }
    }

    // Login check and proper action
    if (!authenticated()) login()
    else {
      if (env.isChektDomain) idToken = getIdTokenFromCookie()
      else idToken = getIdTokenFromLocalStorage()
      setTimeout(() => { login() }, tokenExpirationTimeLeft(idToken))
      setInterval(() => { if (!authenticated()) login() }, 1000 * 60) // check every 1 min
      console.log('New login required after ' + Math.round(tokenExpirationTimeLeft(idToken) / 1000 / 60) + ' minutes.')
    }

    let service = {
      idToken: idToken,
      authenticated: authenticated,
      login: login,
      logout: logout,
      storeIdTokenToLocalStorage: storeIdTokenToLocalStorage
    }

    Vue.prototype.$auth = service
    Vue.auth = service
  }
}

export default AuthPlugin



// WEBPACK FOOTER //
// ./src/plugins/auth.js